import * as THREE from "three";
import { City } from "./ENTITIES/City";

export class Cities {

    constructor(store) {
        this.store = store;
        this.group = new THREE.Group();
    }

    render() {
        const locations = this.store.database.actualLocations || [];
        const possibleLocations = this.store.database.possiblyLocations || [];
        this.store.cityList = [];

        // AKTUÁLIS HELYEK
        locations.forEach((city, index) => {
            const spawnCity = new City(this.store, this.store.ui.group, city.name, index, city.district, false);
            spawnCity.group.position.set(Number(city.threeX), 0.5, Number(city.threeZ));
            this.store.cityList.push(spawnCity);
        });

        // LEHETSÉGES HELYEK
        possibleLocations.forEach((city, index) => {
            const spawnCity = new City(this.store, this.store.ui.group, city.name, `possible-${index}`, city.district, true);
            spawnCity.group.position.set(Number(city.threeX), 0.5, Number(city.threeZ));
            this.store.cityList.push(spawnCity);
        });
   
    }
    
    update() {this.store.cityList.forEach(city => {city.update();});}

    clear() {
        this.store.cityList.forEach(city => {city.dispose();});
        this.store.cityList = [];
    }
}